import { render, staticRenderFns } from "./AdsCampaigns.vue?vue&type=template&id=5b592cd9"
import script from "./AdsCampaigns.vue?vue&type=script&lang=js"
export * from "./AdsCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports